import { useState } from "react";
import PropTypes from "prop-types";

import {
  StyledEngineProvider,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  ThemeProvider,
  useTheme
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";

import { mainTheme } from "@aclymatepackages/themes";

import SlideLayout from "../../layouts/SlideLayout";

import SupportSlider from "../../modules/SupportSlider";

export const useSupportSlider = ({
  email,
  userName,
  companyName,
  subject,
  message,
  showHelpCenter = true
} = {}) => {
  const [supportSliderOpen, setSupportSliderOpen] = useState(false);

  const openSupport = () => setSupportSliderOpen(true);

  const supportSliderJsx = supportSliderOpen ? (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={mainTheme}>
        <SlideLayout
          isSlideOpen
          setIsSlideOpen={setSupportSliderOpen}
          header={
            <Typography variant="h5" color="textPrimary">
              Let us help you find what you need
            </Typography>
          }
          content={
            <SupportSlider
              email={email}
              userName={userName}
              companyName={companyName}
              subject={subject}
              message={message}
              showHelpCenter={showHelpCenter}
            />
          }
        />
      </ThemeProvider>
    </StyledEngineProvider>
  ) : null;

  return { openSupport, supportSliderJsx };
};

const TopBarSupportIcon = ({
  email,
  userName,
  companyName,
  showHelpCenter = true
}) => {
  const { palette } = useTheme();

  const { openSupport, supportSliderJsx } = useSupportSlider({
    email,
    userName,
    companyName,
    showHelpCenter
  });

  return (
    <>
      {supportSliderJsx}
      <Grid item>
        <Tooltip title="Aclymate Help Center">
          <span>
            <IconButton
              style={{ color: palette.text.primary }}
              onClick={openSupport}
              size="large"
            >
              <FontAwesomeIcon icon={faQuestionCircle} />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </>
  );
};
TopBarSupportIcon.propTypes = {
  email: PropTypes.string,
  userName: PropTypes.string,
  companyName: PropTypes.string,
  showHelpCenter: PropTypes.bool
};

export default TopBarSupportIcon;
